import { getPhoneNumberScreenFormat, getPhoneNumberServerFormat } from '../../utils/formatters';
import { PHONE_MASK } from '../../constants/form';
import { createMaskedInput } from './MaskedInput';

export const MaskedPhoneInput = createMaskedInput(
  {
    mask: PHONE_MASK,
    type: 'tel',
  },
  getPhoneNumberScreenFormat,
  getPhoneNumberServerFormat,
);
